export const EVENT_TYPE = {
  TRIGGERED: 'Triggered',
  RESOLVED: 'Resolved',
  CLEAN: 'Clean',
  TRIGGERING: 'Triggering'
};

export const ALERT_SORT_OPTION = {
  NONE: 0,
  NAME_ASCENDING: 1,
  LAST_TRIGGER_NEWEST_FIRST: 2,
  LAST_TRIGGER_OLDEST_FIRST: 3
};

export const ALERT_FILTER_OPTION = {
  NONE: 0,
  FIRING: 1,
  FIRED: 2,
  SNOOZED: 3,
  CLEAN: 4
};

export const HISTORY_SORT_OPTION = {
  NONE: 0,
  NEWEST_FIRST: 1,
  OLDEST_FIRST: 2,
  TRIGGER_LOWEST_FIRST: 3,
  TRIGGER_HIGHEST_FIRST: 4
};

export const HISTORY_FILTER_OPTION = {
  NONE: 0,
  HITS_IN_LAST_24_HOURS: 1,
  FIRST_HIT: 2,
  RESOLVED: 3
};

export const TRIGGER_SORT_OPTION = {
  NONE: 0,
  TRIGGER_LOWEST_FIRST: 1,
  TRIGGER_HIGHEST_FIRST: 2
};

export const TRIGGER_FILTER_OPTION = {
  NONE: 0,
  TRIGGERING: 1,
  TRIGGERED: 2,
  CLEAN: 3
};

export const STATUS = {
  FIRING: 'Firing',
  FIRED: 'Fired',
  SNOOZED: 'Snoozed',
  CLEAN: 'Clean'
};

export const TRIGGER_STATUS = {
  TRIGGERING: 'Triggering',
  TRIGGERED: 'Triggered',
  CLEAN: 'Clean'
};

export const TRIGGER_TYPE = {
  PREFIX_ANNOUNCED_BY_ASN: 0,
  PREFIX_DELEGATED_TO_ACCOUNT: 1,
  PREFIX_SELECTED_INDIVIDUALLY: 2
};

export const DAYS_OF_CURRENT_HITS_PERIOD = 30;

export const NUMBER_OF_TOP_TRIGGERS = 5;

export const START_DATE_OF_ALERTS_FEATURE = '2022-01-01';

export const ACTION_CHANNEL_TYPE = {
  EMAIL: 1,
  SMS: 2,
  SLACK: 3
};

export const EMAIL_RECIPIENT_TYPE = {
  MYSELF: 1,
  MEMBER_CONTACT: 2,
  PROVIDED_ADDRESS: 3
};

export const RECIPIENT_TYPE_IN_API = {
  APNIC_USER: 'apnicUser',
  NON_APNIC_USER: 'nonApnicUser'
};

export const ACTION_SORT_OPTION = {
  NONE: 0,
  RECIPIENT_ASCENDING: 1,
  RECIPIENT_DESCENDING: 2
};

export const ACTION_FILTER_OPTION = {
  NONE: 0,
  EMAIL_ONLY: 1,
  SMS_ONLY: 2,
  SLACK_ONLY: 3
};

export const ALERTS_REQUEST = {
  channel: {
    email: 'email',
    sms: 'sms',
    slack: 'slack'
  }
};
